var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 17.536 17.536 5 33 5C48.464 5 61 17.536 61 33C61 48.464 48.464 61 33 61C17.536 61 5 48.464 5 33Z",
    fill: "#F7FFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0832 27.7499L41.1665 23.6666M43.4998 21.3333L41.1665 23.6666L43.4998 21.3333ZM32.2882 32.5449C32.8906 33.1393 33.3694 33.847 33.6972 34.6272C34.025 35.4074 34.1952 36.2447 34.198 37.091C34.2009 37.9373 34.0363 38.7757 33.7137 39.5581C33.3912 40.3405 32.9171 41.0514 32.3187 41.6498C31.7203 42.2482 31.0094 42.7223 30.227 43.0448C29.4446 43.3674 28.6062 43.532 27.7599 43.5291C26.9136 43.5263 26.0763 43.3561 25.2961 43.0283C24.5159 42.7005 23.8082 42.2216 23.2138 41.6193C22.045 40.4091 21.3982 38.7882 21.4128 37.1058C21.4275 35.4233 22.1023 33.814 23.292 32.6242C24.4817 31.4345 26.0911 30.7597 27.7735 30.7451C29.4559 30.7305 31.0768 31.3772 32.287 32.5461L32.2882 32.5449ZM32.2882 32.5449L37.0832 27.7499L32.2882 32.5449ZM37.0832 27.7499L40.5832 31.2499L44.6665 27.1666L41.1665 23.6666L37.0832 27.7499Z",
    stroke: "#2A870E",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56C20.2975 56 10 45.7025 10 33H0C0 51.2254 14.7746 66 33 66V56ZM56 33C56 45.7025 45.7025 56 33 56V66C51.2254 66 66 51.2254 66 33H56ZM33 10C45.7025 10 56 20.2975 56 33H66C66 14.7746 51.2254 0 33 0V10ZM33 0C14.7746 0 0 14.7746 0 33H10C10 20.2975 20.2975 10 33 10V0Z",
    fill: "#F9F5FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIcon);
export default __webpack_public_path__ + "static/media/featured_icon.a5ffad3dbf241d43b0088a6b030996ea.svg";
export { ForwardRef as ReactComponent };